import React from 'react';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  duration: string;
  testimonial: string;
}
const TestimonialCard = ({
  name,
  location,
  duration,
  testimonial
}: TestimonialCardProps) => {
  return <div className="border-l-2 border-gray-800 pl-5 py-4 my-6 bg-gray-50 rounded-r shadow-sm" data-id="element-18189" data-mp="2p7g7tnfcm8lf">
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed text-base" data-id="element-18190" data-mp="2u6rokwfpte30">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center border-t border-gray-200 pt-3" data-id="element-18191" data-mp="2z4tcbuo361kt">
        <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-18192" data-mp="344fn7xgfz5qg">
          <UserIcon className="h-3 w-3 text-gray-600" data-id="element-18193" data-mp="386aqh7hxnt6v" />
        </div>
        <div className="text-sm text-gray-600" data-id="element-18194" data-mp="384g9g49s8l82">
          <span className="font-medium text-gray-800" data-id="element-18195" data-mp="19rppf4mydcds">{name}</span>
          <span className="mx-1" data-id="element-18196" data-mp="1dsjisdj5zje2">•</span>
          <span data-id="element-18197" data-mp="1dtkvemftwdxw">{location}</span>
          <span className="mx-1" data-id="element-18198" data-mp="1dum4wmh74sdi">•</span>
          <span data-id="element-18199" data-mp="htcnq61m7nx0">Using product for {duration}</span>
        </div>
        <div className="ml-2 flex items-center text-green-600 text-xs font-medium border border-green-200 rounded-full px-2 py-0.5 bg-green-50" data-id="element-18200" data-mp="hunpy1fewnm0">
          <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-18201" data-mp="828apbvi2d4t" />
          <span data-id="element-18202" data-mp="80oq592t9fx8">Verified</span>
        </div>
      </div>
    </div>;
};
export default TestimonialCard;